import { getCountryName } from '@ca/common'
import type { CreateCustomerData } from '../schemas'
import { hasAnyInvoiceData } from './invoice'

type FormatDate = (date: Date) => string

export const getPersonalDetailLines = (
  data: Partial<CreateCustomerData>,
  formatDate: FormatDate
) => {
  const { first_name, last_name, birthday } = data
  if (!first_name && !last_name) {
    return undefined
  }
  return [
    [first_name, last_name].filter(Boolean).join(' '),
    birthday ? formatDate(birthday) : undefined,
  ]
}

export const getContactDetailLines = (data: Partial<CreateCustomerData>) => {
  const { email, mobile, phone } = data
  if (!email && !mobile && !phone) {
    return undefined
  }
  return [email, mobile, phone].filter(Boolean) as string[]
}

export const getAddressDetailLines = (
  data: Partial<CreateCustomerData>,
  locale: string
) => {
  const { address } = data
  if (!address?.street && !address?.city) {
    return undefined
  }
  return [
    [address.street, address.street2].filter(Boolean).join(' '),
    [address.zip, address.city].filter(Boolean).join(' '),
    [getCountryName(address.country_code, locale), address.country_code]
      .filter(Boolean)
      .join(' '),
  ].filter(Boolean) as string[]
}

export const getInvoiceDetailLines = (data: Partial<CreateCustomerData>) => {
  const { invoice } = data
  if (!hasAnyInvoiceData(invoice)) {
    return undefined
  }
  if (!invoice) {
    return undefined
  }
  return [
    [invoice.firstName, invoice.lastName].filter(Boolean).join(' '),
    invoice.birth_date,
    invoice.email,
    invoice.mobile,
    [invoice.street, invoice.street2].filter(Boolean).join(' '),
    [invoice.zip, invoice.city].filter(Boolean).join(' '),
  ].filter(Boolean) as string[]
}
